import { Side } from "@radix-ui/popper";
import {
  Arrow as TooltipArrow,
  Content as TooltipContent,
  Root as TooltipRoot,
  Trigger as TooltipTrigger,
} from "@radix-ui/react-tooltip";
import React from "react";

import css from "./Tooltip.module.css";

type Props = {
  children: React.ReactNode;
  tooltipContent: React.ReactNode;
  showTooltip: boolean;
  side?: Side;
  open?: boolean;
  delayDuration?: number;
};

const Tooltip = ({
  tooltipContent,
  children,
  showTooltip,
  side = "bottom",
  open,
  delayDuration,
}: Props) => {
  if (!showTooltip) {
    return <>{children}</>;
  }

  return (
    <TooltipRoot delayDuration={delayDuration} open={open}>
      <TooltipTrigger asChild className={css.tooltipContainer}>
        {children}
      </TooltipTrigger>
      <TooltipContent side={side} asChild sideOffset={10}>
        <div className={css.tooltipContent}>
          <TooltipArrow className={css.arrow} />
          {tooltipContent}
        </div>
      </TooltipContent>
    </TooltipRoot>
  );
};

export default Tooltip;
